const numeral: any = require('numeral');

export class FormattingHelper {
	static mask(text: string): string {
		return '****' + (text.length < 4 ? '' : text.substring(text.length - 4));
	}

	static formatCurrency(amount: number): string {
		return numeral(amount).format('($0,0.00)');
	}
}
